import React, { useState, useEffect } from 'react'
import InfoCards from 'components/InfoCards'
import WorkTickIcon from 'components/icons/WorkTickIcon'
import WorkCloseIcon from 'components/icons/WorkCloseIcon'
import WorkOfferIcon from 'components/icons/WorkOfferIcon'
import { Tabs } from 'antd'
import {
  SectionWrapper,
  TopHeader,
  TopHeading,
  CardRow,
  TabDiv
} from 'modules/OfferLetter/Style/style'
import StyledTabs from 'components/TabsPaneStyles/index'
import SingleListed from 'modules/OfferLetter/Style/singleListed'
import { useParams } from 'react-router-dom'
import { permittedEventCruds } from '../../utils/permissionsValidation'
const { TabPane } = Tabs
const OfferLetter = ({
  getOfferList,
  offerLetterList,
  OfferAcceptReject,
  getOfferMetric,
  offerMetric,
  getUserCorpList,
  permissions,
  getNotificationCatalogues,
  sendNotificationEmail,
  sendNotificationBulkEmail,
  getStudentData, 
  studentDetails,
  candidateJoined,
  sendInAppNotification
}) => {
  const params = useParams()
  const [filter, setFilter] = useState(params?.Status || 'ACTIVE')
  const [page, setPage] = useState(1)
  const tabValue = params?.Status
  const [loading, setLoading] = useState(false)
  const [offerAccpectTemplate, setOfferAccpectTemplate] = useState(null)
  const [offerRejectTemplate, setOfferRejectTemplate] = useState(null)
  const [offerRejectTemplateEx, setOfferRejectTemplateEx] = useState(null)
  const [offerNegotiateTemplate, setOfferNegotiateTemplate] = useState(null)
  const permittedEvents = permittedEventCruds(permissions, 'OFFER RELEASED')

  const offerAccept =
    permittedEvents?.find(item => item.events?.eventName === 'ACTION')
      ?.events || ''
      useEffect(() => {
        (async () => {
          if (offerAccept?.id) {
            let responce = await getNotificationCatalogues(offerAccept?.id)
            const filteredArray = responce?.CatalogueData?.filter(
              item =>
                item.eventNotificationTemplate &&
                item.eventNotificationTemplate.templateName ===
                  'Offer Letter Accepted' &&
                item.eventNotificationTemplate.eventNotificationType &&
                item.eventNotificationTemplate.eventNotificationType.name ===
                  'E-Mail'
            )
    
            if (filteredArray?.length > 0) {
              setOfferAccpectTemplate(filteredArray[0].eventNotificationTemplate)
            }

            const filteredArray1 = responce?.CatalogueData?.filter(
              item =>
                item.eventNotificationTemplate &&
                item.eventNotificationTemplate.templateName ===
                  'Offer Letter Rejected' &&
                item.eventNotificationTemplate.eventNotificationType &&
                item.eventNotificationTemplate.eventNotificationType.name ===
                  'E-Mail'
            )
    
            if (filteredArray1?.length > 0) {
              
              setOfferRejectTemplate(filteredArray1[0].eventNotificationTemplate)
            }

            const filteredArray2 = responce?.CatalogueData?.filter(
              item =>
                item.eventNotificationTemplate &&
                item.eventNotificationTemplate.templateName ===
                  'Offer Letter Rejected EX' &&
                item.eventNotificationTemplate.eventNotificationType &&
                item.eventNotificationTemplate.eventNotificationType.name ===
                  'E-Mail'
            )
    
            if (filteredArray2?.length > 0) {
              setOfferRejectTemplateEx(filteredArray2[0].eventNotificationTemplate)
            }

            const filteredArray3 = responce?.CatalogueData?.filter(
              item =>
                item.eventNotificationTemplate &&
                item.eventNotificationTemplate.templateName ===
                  'Offer Negotiation' &&
                item.eventNotificationTemplate.eventNotificationType &&
                item.eventNotificationTemplate.eventNotificationType.name ===
                  'E-Mail'
            )
    
            if (filteredArray3?.length > 0) {
              setOfferNegotiateTemplate(filteredArray3[0].eventNotificationTemplate)
            }
          }
        })()
    
        return () => {
          // this now gets called when the component unmounts
        }
      }, [offerAccept])

 
  useEffect(() => {
    getOfferList({page,filter,setLoading})
  },[page,filter])
 useEffect(() => {
  getOfferMetric()
 },[])

 useEffect(() => {
  getStudentData()
}, [])

const updateDataCall  = () =>{
  getOfferList({page,filter,setLoading})
}

  const [cardsData, setCardsData] = useState([])
  const onChange = key => {
    setFilter(key)
    setPage(1)

  }
  const onPageChange = key => {
    setPage(key)

  }

  useEffect(() => {
    const cardData = [
      {
        key: '1',
        icon: <WorkOfferIcon />,
        text: 'Offers Received',
        value: offerMetric?.offerRecived,
      },
      {
        key: '2',
        icon: <WorkTickIcon />,
        text: 'Active',
        value: offerMetric?.active,
      },
      {
        key: '2',
        icon: <WorkTickIcon />,
        text: 'Offers Accepted',
        value: offerMetric?.accepted,
      },
      {
        key: '3',
        icon: <WorkCloseIcon />,
        text: 'Declined',
        value: offerMetric?.rejected,
      },
   
    ]
    setCardsData(cardData)
  }, [offerMetric])

  return (
    
      <SectionWrapper column>
        <TopHeader row spaceBetween alignCenter>
          <TopHeading flexStart>Offer Received</TopHeading>
        </TopHeader>

        <CardRow spaceBetween>
          {cardsData?.map((card,index) => (
            <InfoCards
              padding={'20px'}
              width={'33%'}
              key={index+"card"}
              icon={card?.icon}
              text={card?.text}
              value={card?.value}
            />
          ))}
        </CardRow>

        <TabDiv>
          <StyledTabs defaultActiveKey={tabValue} onChange={onChange}>
            <TabPane tab="Active" key="ACTIVE">
            <SingleListed
            offerLetterList={offerLetterList}
            offerAccpectTemplate={offerAccpectTemplate}
            offerRejectTemplate={offerRejectTemplate}
            offerRejectTemplateEx={offerRejectTemplateEx}
            offerNegotiateTemplate={offerNegotiateTemplate}
                onPageChange={onPageChange}
                OfferAcceptReject={OfferAcceptReject}
                getUserCorpList={getUserCorpList}
                sendNotificationBulkEmail={sendNotificationBulkEmail}
                sendInAppNotification={sendInAppNotification}
                page={page}
                filter={filter}
                setFilter={setFilter}
                updateDataCall={updateDataCall}
                loading={loading}
                getOfferList={getOfferList}
              />
            </TabPane>
            <TabPane tab="Accepted" key="ACCEPTED">
            <SingleListed
             offerLetterList={offerLetterList}
             offerAccpectTemplate={offerAccpectTemplate}
             offerRejectTemplate={offerRejectTemplate}
             offerRejectTemplateEx={offerRejectTemplateEx}
             offerNegotiateTemplate={offerNegotiateTemplate}
                onPageChange={onPageChange}
                OfferAcceptReject={OfferAcceptReject}
                getUserCorpList={getUserCorpList}
                sendNotificationBulkEmail={sendNotificationBulkEmail}
                sendInAppNotification={sendInAppNotification}
                page={page}
                filter={filter}
                candidateJoined={candidateJoined}
                loading={loading}
                getOfferList={getOfferList}
              />
            </TabPane>
           
            <TabPane tab="Declined" key="REJECTED">
            <SingleListed
             offerLetterList={offerLetterList}
             offerAccpectTemplate={offerAccpectTemplate}
             offerRejectTemplate={offerRejectTemplate}
             offerRejectTemplateEx={offerRejectTemplateEx}
             offerNegotiateTemplate={offerNegotiateTemplate}
                onPageChange={onPageChange}
                OfferAcceptReject={OfferAcceptReject}
                getUserCorpList={getUserCorpList}
                sendNotificationBulkEmail={sendNotificationBulkEmail}
                sendInAppNotification={sendInAppNotification}
                page={page}
                filter={filter}
                loading={loading}
                getOfferList={getOfferList}
                  />
            </TabPane>
            {studentDetails?.student?.isExpCandidate && (
            <TabPane tab="Negotiated" key="NEGOTIATED">
            <SingleListed
             offerLetterList={offerLetterList}
             offerAccpectTemplate={offerAccpectTemplate}
             offerRejectTemplate={offerRejectTemplate}
             offerRejectTemplateEx={offerRejectTemplateEx}
             offerNegotiateTemplate={offerNegotiateTemplate}
                onPageChange={onPageChange}
                OfferAcceptReject={OfferAcceptReject}
                getUserCorpList={getUserCorpList}
                sendNotificationBulkEmail={sendNotificationBulkEmail}
                sendInAppNotification={sendInAppNotification}
                page={page}
                filter={filter}
                getOfferList={getOfferList}
              />
            </TabPane>
)}
            <TabPane tab="Expired" key="EXPIRED">
        
              <SingleListed
               offerLetterList={offerLetterList}
               offerAccpectTemplate={offerAccpectTemplate}
               offerRejectTemplate={offerRejectTemplate}
               offerRejectTemplateEx={offerRejectTemplateEx}
               offerNegotiateTemplate={offerNegotiateTemplate}
                onPageChange={onPageChange}
                OfferAcceptReject={OfferAcceptReject}
                getUserCorpList={getUserCorpList}
                sendNotificationBulkEmail={sendNotificationBulkEmail}
                sendInAppNotification={sendInAppNotification}
                page={page}
                filter={filter}
                getOfferList={getOfferList}
              />
          
            </TabPane>
          </StyledTabs>
        </TabDiv>
      </SectionWrapper>
    
  )
}
export default OfferLetter
